module.exports = __webpack_public_path__ + "images/ds-js2025-bg-banner-laptop.webp";